import React, { useState, useContext } from "react";
import { Navigate, useNavigate, useLocation } from "react-router-dom";

import { LockClosedIcon } from "@heroicons/react/solid";
import axios from "axios";
import { toast } from "react-toastify";
import backendService from "../services.js/backendService";
import "react-toastify/dist/ReactToastify.css";
import { useBeforeunload, Beforeunload } from "react-beforeunload";
import toastProp from "../global/toastProps";
import { GoogleLogin } from "react-google-login";
import { socket, SocketContext } from "../services.js/socket";


function SigninScreen(props) {
  const navigate = useNavigate();
  const socket = useContext(SocketContext);
  const location = useLocation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [isLogged, setisLogged] = useState(backendService.isLoggedIn());
  const [rememberMe, setRememberme] = useState(true);

  //create function to post request to backend for login
  const handlesubmit = async (e) => {
    if (username.length !== 0 && password.length !== 0) {
      e.preventDefault();
      const id = toast.loading("Please wait...", { theme: "light" });

      try {
        toast.update(id, {
          render: "Logging in...",
          isLoading: true,
          theme: "light",
        });
        setLoading(true);
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/login`,
          JSON.stringify({ username, password, rememberMe }),
          {
            headers: { "Content-Type": "application/json" },
          }
        );

        localStorage.setItem("token", response.data.Token);
        if (rememberMe) {
          localStorage.setItem("rememberMe", rememberMe);
        } else {
          localStorage.setItem("rememberMe", rememberMe);
        }

        setisLogged(backendService.isLoggedIn());
        setLoading(false);
        // toast.success("Login Successful");
        toast.update(id, toastProp("Login Successful", true));
        try {
          socket.connect();
        } catch (error) {
          console.log(error);
        }
      } catch (error) {
        // toast.error(error.response.data["Status"]);
        toast.update(id, toastProp(error.response.data["Status"], false));
        setLoading(false);
        console.log(error.response);
      }
    }
  };
  const handleSuccess = async (response) => {
  
    const id = toast.loading("Please wait...", { theme: "light" });
    await axios
      .post(`${process.env.REACT_APP_URL}/googlelogin`, {
        tokenId: response.tokenId,
      })
      .then((res) => {
        

        localStorage.setItem("token", res.data.Token);
        if (rememberMe) {
          localStorage.setItem("rememberMe", rememberMe);
        } else {
          localStorage.setItem("rememberMe", rememberMe);
        }
        toast.update(id, toastProp("Login Successful", true));
        setisLogged(backendService.isLoggedIn());
      })
      .catch((err) => {
        console.log(err);
        toast.update(id, toastProp(err.response.data["Status"], false));
      });
  };
  const handleFailure = (response) => {
    console.log(response);
  };

  return (
    <>
      {isLogged && location.state?.redirect ? (
        <Navigate replace to={location.state?.redirect} />
      ) : isLogged ? (
        <Navigate to="/home" />
      ) : (
        <div className="h-screen  ">
          <div className="flex h-full items-center justify-center ">
            <div className="flex flex-col items-center p-[3%] m-3 bg-palette_color2 shadow-md shadow-black rounded-lg antialiased">
              <h2 className="font-robo antialiased   text-black   text-center text-3xl ">
                Login to Your Account
              </h2>
              <form className="mt-3 space-y-6" action="#" method="POST">
                <input type="hidden" name="remember" defaultValue="true" />
                <div className="rounded-md shadow-sm space-y-px">
                  <div>
                    <input
                      id="username-address"
                      name="username"
                      type="text"
                      autoComplete="username"
                      required
                      className="appearance-none rounded relative block w-full px-3 py-2 my-3 antialiased  placeholder-secondary  rounded-t-md focus:outline-none focus:z-10 sm:text-sm border-[1px] border-palette_color1"
                      placeholder="Enter username or email"
                      onChange={(e) => setUsername(e.target.value)}
                    />
                    {/* <h3 className="text-sm italic text-red-600 font-bold">
                  * username is required
                </h3>
                <h3 className="text-sm italic text-red-600 font-bold">
                  * username is incorrect
                </h3> */}
                  </div>
                  <div>
                    <input
                      id="password"
                      name="password"
                      type="password"
                      autoComplete="current-password"
                      required
                      className=" rounded relative block w-full px-3 py-2 my-3  placeholder-secondary  focus:outline-none focus:z-10 sm:text-sm antialiased border-[1px] border-palette_color1"
                      placeholder="Enter password"
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    {/* <h3 className="text-sm italic text-red-600 font-bold">
                  * Password is required
                </h3>
                <h3 className="text-sm italic text-red-600 font-bold">
                  * Password is incorrect
                </h3> */}
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <input
                      id="remember-me"
                      name="remember-me"
                      type="checkbox"
                      defaultChecked
                      onChange={(e) => setRememberme(e.target.checked)}
                      className="h-4 w-4 text-palette_color1   rounded"
                    />
                    <label
                      htmlFor="remember-me"
                      className=" font-robo ml-2 block text-base font-light text-black antialiased"
                    >
                      Remember me
                    </label>
                  </div>

                  <div className="text-sm">
                    <a
                      href="/forgot-password"
                      className=" font-robo text-base font-medium text-[#FF0000] hover:text-red-500"
                      onClick={(e) => {
                        e.preventDefault();
                        navigate("/forgot-password");
                      }}
                    >
                      Forgot your password?
                    </a>
                  </div>
                </div>

                <div>
                  <button
                    type="submit"
                    className="font-robo  font-semibold antialiased  group relative w-full flex justify-center py-2 px-4 border-none text-xl rounded-md text-white bg-palette_color1 hover:opacity-80  focus:outline-none shadow-sm"
                    onClick={handlesubmit}
                    disabled={loading ? true : false}
                  >
                    <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                      <LockClosedIcon
                        className="h-5 w-5 text-white "
                        aria-hidden="true"
                      />
                    </span>
                    Log in
                  </button>
                  <div className="flex items-center justify-between w-full my-4">
                    <div className="w-[45%] border-[1px] antialiased border-black"></div>
                    <h3 className="font-medium font-robo  antialiased text-xl">
                      OR
                    </h3>
                    <div className="w-[45%] border-[1px] border-black antialiased"></div>
                  </div>
                  <div className="w-full flex justify-center items-center ">
                    <GoogleLogin
                      className="font-robo antialiased group relative flex justify-center   text-xl uppercase font-medium rounded-md w-[100%] "
                      clientId="508292653640-ndk0l126jsbo2vlu1usj7dlf13ai0k94.apps.googleusercontent.com"
                      buttonText="Login with Google"
                      onSuccess={handleSuccess}
                      onFailure={handleFailure}
                      cookiePolicy={"single_host_origin"}
                    />
                  </div>
                  <div className="flex justify-center">
                    <h1 className="m-5 block text-lg text-black font-robo ">
                      Don't have an account?{" "}
                      <span
                        className="text-palette_color1 font-robo text-xl hover:underline hover:cursor-pointer  "
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/sign-up");
                        }}
                      >
                        Create Account
                      </span>
                    </h1>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SigninScreen;
